import diacritics from 'diacritics';

import { ensure } from '../types/ensure';

interface StringExtensions {
  removeDiacritics(): string;
  replaceEszettWithDoubleS(): string;
  removeSpecialCharacters(): string;
  removeSpaces(): string;
  removeAllDots(): string;
  removeAllDotsExceptLast(): string;
}

export const stringExtensions = (value: string): StringExtensions => {
  const removeDiacritics = () => {
    return diacritics.remove(value);
  };

  const replaceEszettWithDoubleS = () => {
    return value.replaceAll('ß', 'ss');
  };

  const removeSpecialCharacters = () => {
    return value.replaceAll(/[^a-zA-Z0-9 ]/g, '');
  };

  const removeSpaces = () => {
    return value.replaceAll(' ', '');
  };

  const removeAllDots = () => {
    return value.replaceAll('.', '');
  };

  const removeAllDotsExceptLast = () => {
    const filenameParts = value.split('.');

    if (filenameParts.length === 1) {
      return value;
    }

    const lastFilenamePart = filenameParts.pop();
    ensure(lastFilenamePart);

    return `${filenameParts.join('')}.${lastFilenamePart}`;
  };

  return {
    removeDiacritics,
    replaceEszettWithDoubleS,
    removeSpecialCharacters,
    removeSpaces,
    removeAllDots,
    removeAllDotsExceptLast,
  };
};
